// @flow
import * as React from 'react'
import type { ContextRouter } from 'react-router'

import Accessibility from '@/accessibility'
import {
  Hero, InfoSection, Title, SearchBar,
} from '@/components'
// import { Hotel } from '@/models'
import Strings, { Images } from '@/constants'
import { classnames } from '@/helpers'
import INFO from './constants'
import styles from './styles.scss'

const { Hero: HeroAcc } = Accessibility

type Props = {|
  ...$Exact<ContextRouter>,
|}

const HomeScreen = ({ match }: Props) => (
  <div className={styles.background}>
    <Hero
      className={styles.landingBanner}
      imageUrl={Images.landingBanner}
      align="left"
      ariaLabel={HeroAcc.Main}
      backgroundPosition="right"
    />
    <div className={classnames(styles.container, styles.newSearchPaddingBottom)}>
      <SearchBar match={match} />
    </div>
    <div className={styles.container}>
      <div className={classnames(styles.row, styles.allInclusive)} />
      <Title title={Strings.general.choose} subtitle={Strings.general.whyAllInclusive} />
      <div className={classnames(styles.row, styles.threeCol, styles.bottomRow)}>
        {
          INFO.map(d => (
            <InfoSection title={d.title} description={d.description} icon={d.icon} key={d.icon} />
          ))
        }
      </div>
    </div>
  </div>
)

export default HomeScreen
